import { render, staticRenderFns } from "./adminInfo.vue?vue&type=template&id=51ca3614&scoped=true&"
import script from "./adminInfo.js?vue&type=script&lang=js&"
export * from "./adminInfo.js?vue&type=script&lang=js&"
import style0 from "./adminInfo.css?vue&type=style&index=0&id=51ca3614&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ca3614",
  null
  
)

export default component.exports